/*
 * @Descripttion:材料合成池材料
 * @Author: lc
 * @Date: 2021-10-25 08:33:06
 * @LastEditors: lc
 * @LastEditTime: 2021-10-29 11:41:40
 */
import axios from '.././http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块，把请求字段直接映射过来


// 接口请求地址
const api = '/c-api/';

const goodattrtag = {
    // 列表
    list (params) {
        return axios.get(api + 'goodattrtag/list', { params: params })
    },
    //添加
    create (params) {
        return axios.post(api + 'goodattrtag/create', qs.stringify(params))
    },
    //获取编辑信息
    detail (params) {
        return axios.get(api + 'goodattrtag/detail', { params: params })
    },
    //修改
    edit (params) {
        return axios.post(api + 'goodattrtag/edit', qs.stringify(params))
    },
    //删除
    remove (params) {
        return axios.post(api + 'goodattrtag/remove', qs.stringify(params))
    },
}


// 导出接口
export default goodattrtag



